// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TasPm","content":"Footer_content__5GXEN","icons":"Footer_icons__N1Hs-","buttons":"Footer_buttons__p4uWz"};